'use strict';
var populationElements = document.querySelectorAll('.population');
var populations = Array.from(populationElements).map(function(el) {
    return parseInt(el.textContent.replace(/,/g, ''));
});
var total = populations.reduce(function(sum, num) {
    return sum + num;
}, 0);
var average = total / populations.length;
var averageSpan = document.querySelector('.average-population');
var totalSpan = document.querySelector('.total-population');
averageSpan.textContent = Math.round(average).toLocaleString();
totalSpan.textContent = total.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.7f7254fd.js.map
